import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "group peer inline-flex h-6 w-10 shrink-0 cursor-pointer rounded-full relative",
      "transition-colors duration-300 ease-in-out",
      "data-[state=unchecked]:bg-disabled data-[state=checked]:bg-brand-yellow",
      "hover:brightness-95",
      "focus-visible:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none absolute top-1 h-4 w-4 rounded-full",
        "flex items-center justify-center",
        "ring-0",
        "transition-all duration-300 ease-in-out",
        "data-[state=unchecked]:left-1 data-[state=checked]:left-5",
        "data-[state=unchecked]:bg-white data-[state=checked]:bg-filled-1",
      )}
    >
      <svg
        className={cn(
          "h-3 w-3",
          "text-text-primary",
          "transition-opacity duration-300 ease-in-out",
          "opacity-0 group-data-[state=checked]:opacity-100",
        )}
        viewBox="3 3 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 8.00059L7.1 10.1006L11.3 5.60059"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SwitchPrimitives.Thumb>
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
